module.exports = __webpack_public_path__ + "static/media/LU.f8137a63.svg";